import axios from 'axios'

export async function uploadFile ({ file, filename, folder, contentType }) {
  let formData = new FormData()
  formData.append('filename', filename)
  formData.append('file', file)
  formData.append('contentType', contentType || file.type)
  formData.append('folder', folder)
  const baseUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH.replace('/socket.io', '')
  try {
    let res = await axios.post(baseUrl + '/service/drive-upload', formData)
    return res.data.id
  } catch (e) {
    return false
  }
}
